module.exports = __webpack_public_path__ + "static/media/umaCasaConfidentialBlurredLogo.88e43e5e.png";